import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalDbService {


    constructor() {
    }

    setObject(objectKey: string, objectValue: any) {
        localStorage.setItem(objectKey, JSON.stringify(objectValue));
        return true;
    }

    getObject(objectKey: string, defaultValue: any) {
        const value = localStorage.getItem(objectKey);
        return value ? JSON.parse(value) : defaultValue;
    }
}
